import { Typography } from "@mui/material";

import { ArrowDropUp } from "@mui/icons-material";
import { Remove } from "@mui/icons-material";
import { Box } from "@mui/material";

import { useTheme } from "@mui/material";

const PricePerformanceBlock = ({
  averageToFormat,
  value,
  arrowDirection,
  performance,
  ...props
}: {
  averageToFormat: number;
  value: string;
  arrowDirection: "up" | "down" | "none";
  performance: number;
}) => {
  const theme = useTheme();

  return (
    <Box
      padding="4px"
      borderRadius="8px"
      border={`1px solid ${theme.palette.border.dark}`}
      bgcolor={
        averageToFormat === 0
          ? theme.palette.surface["silver"]
          : averageToFormat > 0
          ? theme.palette.system["green"]
          : theme.palette.system["red"]
      }
      {...props}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "end",
          alignItems: "center",
          position: "relative",
          minWidth: "52px",
        }}>
        {averageToFormat !== 0 ? (
          <ArrowDropUp
            sx={{
              position: "absolute",
              left: theme.spacing(-0.75),
              transform: performance < 0 ? "rotate(180deg)" : "none",
            }}
          />
        ) : (
          <Remove
            sx={{
              position: "absolute",
              left: theme.spacing(-0.75),
              width: "12px",
              marginLeft: "4px",
            }}
          />
        )}
        <Typography variant="body-sm" marginLeft={averageToFormat !== 0 ? theme.spacing(2) : 0}>
          {value}
        </Typography>
      </Box>
    </Box>
  );
};

export default PricePerformanceBlock;
